import MPF from "../src/img/MPF.jpg";
import TP from "../src/img/TP.jpg";
import TSLA from "../src/img/TSLA.jpg";
import YT from "../src/img/YT.jpg";
// import GA from "../src/img/GA.jpg";
// import PT from "../src/img/PT.jpg";
import CPT from "../src/img/CPT.png";
import YFOA from "../src/img/YFOA.jpg";
import NIKE from "../src/img/NIKE.jpg";
import HUSKIES from "../src/img/HUSKIES.jpg";
import NETFLIX from "../src/img/NTFLX.JPG";

export const products = [
  {
    id: 1,
    img: NETFLIX,
    link: "https://github.com/DrishtiGoda/Netflix-GPT",
    tag: "web",
  },
  {
    id: 2,
    img: YFOA,
    link: "https://github.com/DrishtiGoda/YumRush-Food-Ordering-App",
    tag: "web",
  },
  {
    id: 3,
    img: NIKE,
    link: "",
    tag: "ui",
  },
  {
    id: 4,
    img: MPF,
    link: "https://github.com/DrishtiGoda/Mobile-Plan-Finder",
    tag: "web",
  },
  {
    id: 5,
    img: TP,
    link: "https://github.com/DrishtiGoda/Trip-Planner",
    tag: "web",
  },
  {
    id: 6,
    img: TSLA,
    link: "https://github.com/bingecode15/Tesla_Cybertruck_App",
    tag: "mobile",
  },
  {
    id: 7,
    img: CPT,
    link: "https://github.com/DrishtiGoda/Cryptocurrency-Price-Tracker",
    tag: "",
  },
  {
    id: 8,
    img: YT,
    link: "https://github.com/bingecode15",
    tag: "",
  },
  {
    id: 9,
    img: HUSKIES,
    link: "",
    tag: "",
  }
];

// {
//   id: 6,
//   img: PT,
//   link: "https://github.com/DrishtiGoda/Portfolio_Website",
//   tag: "",
// },

 // {
  //   id: 7,
  //   img: GA,
  //   link: "https://github.com/DrishtiGoda/Go-Army",
  //   tag: "web",
  // },